import {IEntitySelectionDropdownController, MK_ENTITY_SELECTION_DROPDOWN} from "./IEntitySelectionDropdownController";
import {AbstractController} from "../../../controllers/AbstractController";
import {Injectable, signal} from "@angular/core";
import {EntitySelectionDropdownConfig} from "../../../interfaces/domain/EntitySelectionDropdownConfig";
import {PagingRequest} from "../../../interfaces/rest/paging/PagingRequest";
import {Sort} from "../../../interfaces/rest/paging/Sort";
import {Helper} from "../../../helpers/Helper";

@Injectable()
export class EntitySelectionDropdownController extends AbstractController implements IEntitySelectionDropdownController {

  private pagingRequest?: PagingRequest;

  constructor() {
    super();

    this.addModel(MK_ENTITY_SELECTION_DROPDOWN, {
      config$: signal({
        singleSelection: true,
      }),
      items$: signal([]),
      selectedItems$: signal(null),
    });
  }

  handleInitialConfig(eventData: any): void {
    const initialConfig: EntitySelectionDropdownConfig = eventData['initialConfig'];

    this.getModel(MK_ENTITY_SELECTION_DROPDOWN).config$.set(initialConfig);

    if(initialConfig.dataFetcher) {
      this.fetchInitialData();
    }
    else if(initialConfig.items && initialConfig.items.length > 0) {
      const items = Helper.arrayCopy(initialConfig.items);
      items.forEach((item) => item.label = this.translate(item.label));

      this.getModel(MK_ENTITY_SELECTION_DROPDOWN).items$.set(items);
    }
  }

  handleInitialSelectedItems(eventData: any): void {
    const initialSelectedItems: any = eventData['initialSelectedItems'];
    this.getModel(MK_ENTITY_SELECTION_DROPDOWN).selectedItems$.set(initialSelectedItems);
  }

  handleEndOfList(eventData: any): void {
    // Fetch additional page since user has scrolled to the end.
  }

  handleItemSearch(eventData: any): void {
    // Apply filters to the paging request.
  }

  protected fetchInitialData(): void {
    const model = this.getModel(MK_ENTITY_SELECTION_DROPDOWN);
    const config = model.config$();

    this.pagingRequest = new PagingRequest();
    this.pagingRequest.page = 0;
    this.pagingRequest.pageSize = 1000000; // For now use a large value to load the whole table, implement paging logic later.
    this.pagingRequest.sorts = [];
    this.pagingRequest.filters = [];

    if(config.sortProperty) {
      const sort = new Sort();
      sort.property = config.sortProperty;
      sort.order = config.sortDir || 'ASC';
      this.pagingRequest.sorts.push(sort);
    }

    if(config.dataFetcher && config.labelExtractor && config.valueExtractor) {
      config.dataFetcher(this.pagingRequest).subscribe({
        next: (pagedData) => {
          if(pagedData && pagedData.data) {
            const items: Array<any> = pagedData.data.map((entity) => {
              return {
                label: config.labelExtractor!(entity),
                value: config.valueExtractor!(entity),
              };
            });

            model.items$.set(items);
          }
        }
      });
    }
  }
}
